import { ptBR } from './ptBR'
import { en } from './en'

export default {
  pt: ptBR,
  en: en
}
